import CommunitySupportPage from "@/components/contact-us/CommunitySupportPage";
import NotFound from "@/components/common/NotFound";
import { isProspect } from "@/utils/type";

const CommunitySupport = ({ type }) => {
    return isProspect(type) ? <NotFound /> : <CommunitySupportPage />;
    //return isProspect(type) ? <CommunitySupportPage /> : <NotFound />;
};

export async function getStaticProps() {
    return { props: { type: process.env.NEXT_PUBLIC_TYPE } };
}

export default CommunitySupport;
